
import { parseQueryArguments } from '@/shared'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'

export type TInTableColumnMapping = { field: string, column: string }
export type TInTableColumnFile = {
    _id: string,
    fileName: string,
    sheetName: string,
    client: string,
    useOnMapping: boolean,
}
export type TUploadIndicator = { id: string, progress: number, message: string, maxItems: number }
export type TInTableColumn = {
    _id: string,
    //name: string,
    //fileName: string,
    //client?: string,
    //useOnMapping?: boolean,
    mapping: TInTableColumnMapping[],
    /** keys of the last imported file's columns, in its order */
    columns?: string[],
    files: TInTableColumnFile[],
    outTableId?: string,
    outTableName: string,
    /** a lookup table's name: a list without a template */
    name?: string,
    uploadIndicator?: TUploadIndicator
}

export default class InTableColumnModel implements ITableListModel<TInTableColumn> {
    constructor() {
    }

    public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, project, page = 0, limit = 10, q = '' }: TableListRequestType) {
        let query = parseQueryArguments(`page=${page}&limit=${limit}`, arguments)
        if (q) query += '&q=' + encodeURI(q)
        if (mode == TABLE_REQUEST_MODE.POSITION) {
            query += '&mode=position'
        }
        return await getData(`/projects/${project}/in?${query}`)
    }

    public async read(project: string, id: string) {
        return await getData(`/projects/${project}/in/${id}`)
    }

    public async create(project: string, data: any) {
        return await postData('/projects/${project}/in', data)
    }

    public async update(project: string, id: string, data: any) {
        return await patchData(`/projects/${project}/in/${id}`, data)
    }

    public async updateUseOnMapping(project: string, data: any) {
        return await patchData(`/projects/${project}/in/useonmapping`, data)
    }

    public async delete(project: string, id: string) {
        return await deleteData(`/projects/${project}/in/${id}`)
    }

    public async count(project: string) {
        return await countData(`/projects/${project}/in/count`)
    }

    public async checkUpload(project: string, data: any, options = {}) {
        return await postData(`/projects/${project}/in/check`, data, options)
    }
}